import React, {useMemo} from "react";
import {createPortal} from "react-dom";

export default function Portal({children}: { children: React.ReactNode }) {
  const portal = useMemo(() => document.getElementById("portal"), []);

  return portal && createPortal(children, portal)
}
